import { Atom } from 'AppReact';
import styled, { css } from "styled-components";

const template = styled.div`
  ${({ displayState }) => css`
    display: block;
    text-align: center;

    width: 100%;
    padding: 0.375rem 0.75rem;
    margin-top: 0.5rem;
    font-weight: 400;
    line-height: 1.5;
    
    opacity: 0.65;
    color: #312f43;
    background-color: transparent;
    border-color: #312f43;
    border-radius: 0.25rem;
    border: 1px solid #312f43;

  `}
`;


export default Atom({ type: 'label', dataType: 'string', template })
